export default __webpack_public_path__ + "static/media/nike_logo.3a6f2d14.svg";